import { graphql } from '~publish/graphql'

import { SavedViewFields } from './SavedViewFields'

export const CreateSavedViewMutation = graphql(
  /* GraphQL */ `
    mutation CreateSavedView($input: CreateSavedViewInput!) {
      createSavedView(input: $input) {
        __typename
        ... on SavedView {
          ...SavedViewFields
        }
        ... on MutationError {
          message
        }
      }
    }
  `,
  [SavedViewFields],
)
